import { Alert as ChakraAlert } from "@chakra-ui/react";
import { CloseButton } from "./close-button";
import { forwardRef } from "react";

export const Alert = forwardRef(
  /**
   * @typedef {object} Props
   * @prop {string} title
   * @prop {React.ReactNode} [children]
   * @prop {React.ReactNode} [icon]
   * @prop {boolean} [closable]
   * @prop {() => void} [onClose]
   * @prop {React.ReactNode} [startElement]
   * @prop {React.ReactNode} [endElement]
   */
  /** @param {Props & ChakraAlert.RootProps} props */
  function Alert(props, ref) {
    const {
      title,
      children,
      icon,
      closable,
      onClose,
      startElement,
      endElement,
      ...rest
    } = props;
    return (
      <ChakraAlert.Root ref={ref} {...rest}>
        {startElement || <ChakraAlert.Indicator>{icon}</ChakraAlert.Indicator>}

        {children ? (
          <ChakraAlert.Content>
            <ChakraAlert.Title>{title}</ChakraAlert.Title>

            <ChakraAlert.Description>{children}</ChakraAlert.Description>
          </ChakraAlert.Content>
        ) : (
          <ChakraAlert.Title flex="1">{title}</ChakraAlert.Title>
        )}

        {endElement}

        {closable && (
          <CloseButton
            size="sm"
            pos="relative"
            top="-2"
            insetEnd="-2"
            alignSelf="flex-start"
            onClick={onClose}
          />
        )}
      </ChakraAlert.Root>
    );
  },
);
